import React from "react";

const LayoutStylePanel = ({ layoutStyle, setLayoutStyle, onImageSelect }) => {
  const readImageMeta = (file, previewUrl) =>
    new Promise((resolve) => {
      const img = new Image();
      img.onload = () => {
        resolve({
          width: img.naturalWidth,
          height: img.naturalHeight,
          ratio: img.naturalWidth && img.naturalHeight ? img.naturalWidth / img.naturalHeight : null,
        });
      };
      img.onerror = () => resolve(null);
      img.src = previewUrl;
    });

  const handleImageChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const previewUrl = URL.createObjectURL(file);
    const meta = await readImageMeta(file, previewUrl);
    onImageSelect?.(previewUrl, file, meta);
    e.target.value = "";
  };

  return (
    <div
      style={{
        width: "100%",
        padding: 16,
        background: "var(--bg-panel)",
        borderRadius: 12,
        border: "1px solid var(--border-color)",
        color: "var(--text-primary)",
        display: "flex",
        flexDirection: "column",
        gap: 15,
        height: "fit-content",
        flexShrink: 0
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #333", paddingBottom: 10 }}>
        <h3 style={{ fontSize: 16, color: "#fff" }}>排版樣式</h3>
      </div>

      <select
        value={layoutStyle}
        onChange={(e) => setLayoutStyle(e.target.value)}
        style={{
          width: "100%",
          padding: "10px",
          borderRadius: 8,
          border: "1px solid #444",
          background: "#2c2c2c",
          color: "#fff",
          fontSize: 14,
          outline: "none",
          cursor: "pointer",
        }}
      >
        <option value="standard">單一按鈕 (Single)</option>
        <option value="horizontal">水平雙按鈕 (Horizontal)</option>
        <option value="vertical">垂直雙按鈕 (Vertical)</option>
      </select>

      <div style={{ fontSize: 12, color: "#666", marginTop: 0, textAlign: "right" }}>
        目前樣式：
        <strong style={{ color: "var(--accent-color)", marginLeft: 5 }}>
            {layoutStyle === 'standard' && '標準單按鈕'}
            {layoutStyle === 'horizontal' && '左右並排'}
            {layoutStyle === 'vertical' && '上下堆疊'}
        </strong>
      </div>

      {/* 圖片素材 */}
      <div style={{ borderTop: "1px solid #333", paddingTop: 15 }}>
        <div style={{ fontSize: 13, color: "#aaa", marginBottom: 8 }}>
          <span style={{ color: "var(--accent-color)" }}>發送時自動上傳</span>
        </div>
        <div
          style={{
            border: "2px dashed #444",
            borderRadius: 8,
            padding: "16px 10px",
            textAlign: "center",
            cursor: "pointer",
            position: "relative",
            transition: "all 0.2s",
          }}
          onMouseOver={(e) => (e.currentTarget.style.borderColor = "var(--accent-color)")}
          onMouseOut={(e) => (e.currentTarget.style.borderColor = "#444")}
        >
          <input
            type="file"
            accept="image/*"
            onChange={handleImageChange}
            style={{
              position: "absolute", top: 0, left: 0, width: "100%", height: "100%", opacity: 0, cursor: "pointer",
            }}
          />
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 6 }}>
            <span style={{ fontSize: 22 }}>🖼️</span>
            <span style={{ fontSize: 13, fontWeight: "bold", color: "#ddd" }}>選擇圖片</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LayoutStylePanel;